import {
  Button,
  Card,
  CardActions,
  CardContent,
  CardHeader,
} from "../legacy-ui/materialCompat";
import { FOCUS_BORDER } from "../../config/focusStyles";
import { useFocusable } from "@noriginmedia/norigin-spatial-navigation";
import React, { useEffect } from "react";
import { DesktopAccessDisabledIcon } from "../legacy-ui/icons";
import { useNavigate } from "react-router-dom";

const AccessDeniedScreen = () => {
  const ReturnHome = () => {
    const navigate = useNavigate();
    const { focused, ref, focusSelf } = useFocusable({
      onEnterPress: () => navigate("/"),
    });

    useEffect(() => {
      focusSelf();
    }, []);

    return (
      <Button
        ref={ref}
        radius="full"
        fullWidth
        size="lg"
        onClick={() => navigate("/")}
        className="flex-auto w-full text-lg !bg-zinc-600"
        sx={{
          color: "white",
          fontFamily: "AnjomanMax",
          borderRadius: "15px",
          p: 2,
          border: focused ? FOCUS_BORDER.active : FOCUS_BORDER.inactive,
        }}
      >
        بازگشت به صفحه اصلی
      </Button>
    );
  };
  return (
    <div className="w-screen h-screen flex justify-center items-center">
      <Card className="max-w-[400px] p-3 !bg-zinc-800">
        <div className="flex flex-col gap-3 w-full rounded-xl p-5">
          <DesktopAccessDisabledIcon
            size={60}
            className="mx-auto"
            color="#ec5252"
          />
          <div className="flex flex-col justify-center items-center w-full">
            <p className="!text-white">خطا</p>
            <p className="!text-white text-small font-bold mt-0">دسترسی نامعتبر</p>
          </div>
        </div>
        <CardContent>
          <p className="!text-white">
            صفحه مورد نظر با رده سنی انتخاب شده مطابقت ندارد
          </p>
        </CardContent>
        <CardActions className="justify-center">
          <ReturnHome />
        </CardActions>
      </Card>
    </div>
  );
};

export default AccessDeniedScreen;
